<template>
  <tr>
    <td>
      <div class="cadencia--name">{{ cadencia.name }}</div>
    </td>
    <td>{{ cadencia.description }}</td>
    <td>
      <woot-switch
        size="small"
        class="auto-offline--switch"
        :value="cadencia.active"
        @input="updateCadenciaActive"
      />
    </td>
    <td>{{ formatDate(cadencia.created_at) }}</td>
    <td class="button-wrapper">
      <woot-button
        v-tooltip.top="$t('CADENCIAS.EDIT.BUTTON_TEXT')"
        variant="smooth"
        size="tiny"
        color-scheme="secondary"
        icon="edit"
        @click="$emit('edit', cadencia)"
      />
      <woot-button
        v-tooltip.top="$t('CADENCIAS.DELETE.BUTTON_TEXT')"
        variant="smooth"
        color-scheme="alert"
        size="tiny"
        icon="dismiss-circle"
        @click="$emit('delete', cadencia, index)"
      />
    </td>
  </tr>
</template>
<script>
import format from 'date-fns/format';

export default {
  props: {
    cadencia: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  methods: {
    formatDate(dateString) {
      return format(new Date(dateString), 'dd/MM/yyyy - HH:mm');
    },
    async updateCadenciaActive(active) {
      try {
        await this.$store.dispatch('cadencias/update', {
          cadencia: {
            name: this.cadencia.name,
            description: this.cadencia.description,
            rule_cron: this.cadencia.rule_cron,
            typebot: this.cadencia.typebot,
            active,
          },
          id: this.cadencia.id,
        });
        this.showAlert(
          this.$t('CADENCIAS.EDIT.API.SUCCESS_MESSAGE')
        );
        this.onClose();
      } catch (error) {
        const message =
          error.response?.data?.message ||
          this.$t('CADENCIAS.EDIT.API.ERROR_MESSAGE');
        this.showAlert(message);
      }
    },
  }
};
</script>
<style scoped lang="scss">
.cadencia--name {
  color: var(--s-700);
  font-weight: var(--font-weight-medium);
  word-break: break-word;
}

.button-wrapper {
  max-width: var(--space-mega);
  min-width: auto;

  button:nth-child(2), button:nth-child(3) {
    margin-left: var(--space-normal);
  }
}
</style>
